<div class="container-fluid"> 
    <div class="">
        <div class="row">
           <div class="col-sm-6" [ngClass]="{'col-sm-6': showPatServices, 'col-sm-12': !showPatServices}">
             <emr-pat-all-visits (emitPatVisitData)="getPatServices($event)"></emr-pat-all-visits>
           </div>
           <div class="col-sm-6" *ngIf="showPatServices">
            <app-service-history></app-service-history>
          </div>
        </div>
    </div> 
</div>